import { Fragment } from "react"
import Container from '../../../core/controls/components/container'
import AnnouncementsContainer from "../../jsons/announcements/announncementsgrid"


const Announcements = (props) => {

    return (
        <Fragment>
            <Container {...AnnouncementsContainer}  {...props} />
        </Fragment>
    )
}
export default Announcements